import { render } from "./HousingRequirements.vue?vue&type=template&id=3b254843"
import script from "./HousingRequirements.vue?vue&type=script&lang=js"
export * from "./HousingRequirements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__